import WSConnectManager from "@/pages/WebSocketConnect";

// Single Pages
import AuthLayout from "@/pages/Auth/AuthLayout.vue";
import Login from "@/pages/Auth/Login.vue";
import EditProfile from "@/pages/User/EditProfile.vue";


//Devices
import WSDevicesManager from "@/pages/Devices/WSDevicesManager.vue";
import DashboardLayout from "@/pages/Devices/Layout/DevicesLayout.vue";
import DevicesSettings from "@/pages/Devices/Settings/DeviceDetails.vue";

//Visualization
//Profile
import VoltageProfile from "@/pages/Devices/Visualization/profiles/Voltage.vue";
import CurrentProfile from "@/pages/Devices/Visualization/profiles/Current.vue";
import ActivePower from "@/pages/Devices/Visualization/profiles/ActivePower.vue";
import ReactivePower from "@/pages/Devices/Visualization/profiles/ReactivePower.vue";
import ApparentPower from "@/pages/Devices/Visualization/profiles/ApparentPower.vue";
import EnergyImport from "@/pages/Devices/Visualization/profiles/EnergyImport";
import EnergyExport from "@/pages/Devices/Visualization/profiles/EnergyExport";
//AppliedPrecision
import ReactiveEnergyProfile from "@/pages/Devices/Visualization/profiles/ReactiveEnergy";
import ApparentEnergyProfile from "@/pages/Devices/Visualization/profiles/ApparentEnergy";
import FrequencyProfile from "@/pages/Devices/Visualization/profiles/Frequency";
import PowerFactorProfile from "@/pages/Devices/Visualization/profiles/PowerFactor";
import DistorationFactorVoltageProfile from "@/pages/Devices/Visualization/profiles/DistorationFactorVoltage";
import DistorationFactorCurrentProfile from "@/pages/Devices/Visualization/profiles/DistorationFactorCurrent";

//Analytics
import Power15MinMaximum from "@/pages/Devices/Visualization/energy/Power15MinMaximum";
//import Energy15MinMaximum from "@/pages/Devices/Visualization/energy/Energy15MinMaximum";
import Energy15Min from "@/pages/Devices/Visualization/energy/Energy15Min";
import EnergyHour from "@/pages/Devices/Visualization/energy/EnergyHour";
import EnergyDay from "@/pages/Devices/Visualization/energy/EnergyDay";
import EnergyMonth from "@/pages/Devices/Visualization/energy/EnergyMonth";
import ReactiveDay from "@/pages/Devices/Visualization/energy/ReactiveDay";

//RealTime
import RealTimeDataManager from "@/pages/Devices/Visualization/realtime/RealtimeDataManager"
import RealTimeVoltage from "@/pages/Devices/Visualization/realtime/Voltage"
import RealTimeCurrent from "@/pages/Devices/Visualization/realtime/Current"
import RealTimeActivePower from "@/pages/Devices/Visualization/realtime/ActivePower"
import RealTimeReactivePower from "@/pages/Devices/Visualization/realtime/ReactivePower"
import RealTimeApparentPower from "@/pages/Devices/Visualization/realtime/ApparentPower"
import RealTimeEnergyImport from "@/pages/Devices/Visualization/realtime/EnergyImport"
import RealTimeEnergyExport from "@/pages/Devices/Visualization/realtime/EnergyExport"
//AppliedPrecision
import RealTimeFrequency from "@/pages/Devices/Visualization/realtime/Frequency"
import RealTimePowerFactor from "@/pages/Devices/Visualization/realtime/PowerFactor"
import RealTimeDistorationFactorVoltage from "@/pages/Devices/Visualization/realtime/DistorationFactorVoltage"
import RealTimeDistorationFactorCurrent from "@/pages/Devices/Visualization/realtime/DistorationFactorCurrent"
import RealTimeReactiveEnergy from "@/pages/Devices/Visualization/realtime/ReactiveEnergy"
import RealTimeApparentEnergy from "@/pages/Devices/Visualization/realtime/ApparentEnergy"


//MeriTo
import Dashboard from "@/pages/Devices/MeriTo/Dashboard.vue";
import Dashboard2 from "@/pages/Devices/MeriTo/RecognitionDashboard.vue";
import AddTarif from "@/pages/Devices/MeriTo/AddTarif.vue"

//NILM
import appliancesRecording from "@/pages/Devices/MeriTo/NILM/AppliancesRecording"
import appliancesImprints from "@/pages/Devices/MeriTo/NILM/AppliancesImprints"
import appliancesEnergy from "@/pages/Devices/MeriTo/NILM/AppliancesEnergy"
import appliancesTimeline from "@/pages/Devices/MeriTo/NILM/AppliancesTimeline"
import appliancesRunProfile from "@/pages/Devices/MeriTo/NILM/AppliancesRunProfile"
import NILMSettings from "@/pages/Devices/MeriTo/NILM/Settings"
import appliancesShapesRising from "@/pages/Devices/MeriTo/NILM/AppliancesShapesRising"
import appliancesShapesFalling from "@/pages/Devices/MeriTo/NILM/AppliancesShapesFalling"
import AnomalyChart from "@/pages/Devices/MeriTo/NILM/AnomalyChart"


//Tools
import Monitoring from "@/pages/Devices/Tools/Monitoring"
import Integration from "@/pages/Devices/Tools/Integration/Integration"
import Upgrade from "@/pages/Devices/Tools/Upgrade"
import Notifications from "@/pages/Devices/Tools/Notifications"

//Disconnector
import disconnectorDashboard from "@/pages/Devices/Disconnector/Dashboard";
import disconnectorTimeline from "@/pages/Devices/Disconnector/Timeline"
import disconnectorProfile from "@/pages/Devices/Disconnector/Profile"
import disconnectorEnergyDay from "@/pages/Devices/Disconnector/energy/Day"
import disconnectorEnergyHour from "@/pages/Devices/Disconnector/energy/Hour"
import disconnectorEnergyMonth from "@/pages/Devices/Disconnector/energy/Month"

//AppliedPrecision
import precisionDashboard from "@/pages/Devices/AppliedPrecision/Dashboard"
import ap_addMeter from "@/pages/Devices/AppliedPrecision/AddMeter/AddMeter"
import ap_meters from "@/pages/Devices/AppliedPrecision/Meters"
import ap_meters_tests from "@/pages/Devices/AppliedPrecision/MeterTestResults/MetersTests"
import ap_vectorDiagram from "@/pages/Devices/AppliedPrecision/VectorDiagram/VectorDiagram"
import ap_harmonicsChart from "@/pages/Devices/AppliedPrecision/HarmonicsChart"
import ap_waveformChart from "@/pages/Devices/AppliedPrecision/WaveformChart"


//Octopus
import OctopusDashboard from "@/pages/Devices/Octopus/Dashboard"

//OutageDetector
import OutageDetectorDashboard from "@/pages/Devices/OutageDetector/Dashboard"
import OutageDetectorVoltageProfile from "@/pages/Devices/OutageDetector/VoltageProfile"
import OutageDetectorVoltageRealtime from "@/pages/Devices/OutageDetector/VoltageRealtime"

//MeriToNano
import MeriToNanoDashboard from "@/pages/Devices/MeriToNano/Dashboard"


//Applications
import ApplicationsLayout from "@/pages/Applications/Layout/ApplicationsLayout"
import WSApplicationsManager from "@/pages/Applications/Pages/WSManager"

//AccuTest
import accuTest_createTestProfile from "@/pages/Applications/Pages/AccuTest/CreateTestProfile/Main"
import accuTest_WS_Manager from "@/pages/Applications/Pages/AccuTest/WSDataManager"
import accuTest_testing from "@/pages/Applications/Pages/AccuTest/Testing"
import accutest_results from "@/pages/Applications/Pages/AccuTest/Results"

//Report
import report_activeEnergyImport from "@/pages/Applications/Pages/Report/ActiveEnergyImport"
import report_activeEnergyExport from "@/pages/Applications/Pages/Report/ActiveEnergyExport"
import report_reactiveEnergy from "@/pages/Applications/Pages/Report/ReactiveEnergy"

//Controller
import controller_state from "@/pages/Applications/Pages/Controller/State"
import controller_timeline from "@/pages/Applications/Pages/Controller/Timeline"
import controller_map from "@/pages/Applications/Pages/Controller/ControlMap"

//UserManager
import userManager from "@/pages/Applications/Pages/UserManager/UserManager"


//Public
import PublicLayout from "@/pages/Public/Layout/PublicLayout"
import PublicWebSocketManager from "@/pages/Public/Pages/WebSocketManager"

//Public Dashboard
import PublicDashboard from "@/pages/Public/Pages/Dashboard"



import { getDeviceList } from '@/storage/memoryStorage';
import store from '@/storage/store';
import config from "@/config/config";


function getAuth() {
  return store.getters.getAuth;
}

function selectedDevice() {
  return store.getters.getSelectedDevice;
}

function isSignedIn() {
  try {
    if ((getAuth().expiration > new Date().getTime()) && getDeviceList().length > 0) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}

function requireAuth(to, from, next) {

  if (!isSignedIn()) {
    next({
      path: '/login'
    });
  } else {
    next();
  }
}

function visualizationAccess(to, from, next) {
  try {
    if (
      selectedDevice().type == config.devices.merito.id || 
      selectedDevice().type == config.devices.precision.id || 
      selectedDevice().type == config.devices.octopus.id ||
      selectedDevice().type == config.devices.meritonano.id) 
      {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function deviceAccess(to, from, next, deviceType) {
  try {
    if (selectedDevice().type == deviceType) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function ownerAccess(to, from, next) {
  try {
    if (selectedDevice().owner === true) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function NILMAccess(to, from, next) {
  try {
    if (selectedDevice().NILM == true) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function userAccess(to, from, next) {
  try {
    if (getAuth().id === 1 && getAuth().user !== 'demo') {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function applicationAccess(to, from, next) {
  try {
    if (getAuth().applications.length > 0) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function integrationAccess(to, from, next) {
  try {
    if (getAuth().sections.integration === true) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}


import { getUserToken } from "@/storage/memoryStorage";
import axios from "axios";
import Vue from 'vue'

function appAcces(to, from, next, application) {
  axios({
    method: "POST",
    url: Vue.prototype.$ENDPOINTS.API_R + "/applications/access",
    data: {
      user_token: getUserToken(),
      application: application,
    },
    withCredentials: true
  })
    .then(response => {
      next();
    })
    .catch(error => {
      next(handleRedirect());
    });
}

export function handleRedirect() {
  if (!isSignedIn()) {
    return "/login";
  } else {
    if (selectedDevice().type === config.devices.merito.id) {
      return "/merito/dashboard";
    } else if (selectedDevice().type === config.devices.disconnector.id) {
      return "/disconnector/dashboard";
    } else if (selectedDevice().type === config.devices.precision.id) {
      return "/applied-precision/dashboard";
    } else if (selectedDevice().type === config.devices.octopus.id) {
      return "/octopus/dashboard";
    } else if (selectedDevice().type === config.devices.outage_detector.id) {
      return "/outage-detector/dashboard";
    } else if (selectedDevice().type === config.devices.meritonano.id) {
      return "/meritonano/dashboard";
    }
  }
}

const deviceMeritoNILM = {
  path: "merito/nilm",
  component: DashboardLayout,
  redirect: "nilm/appliances/energy",
  name: "NILM",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    NILMAccess(to, from, next);
  },
  children: [
    {
      path: "appliances/imprints",
      name: "appliances_imprints",
      components: { default: appliancesImprints }
    },
    {
      path: "appliances/energy",
      name: "appliances_energy",
      components: { default: appliancesEnergy }
    },
    {
      path: "appliances/timeline",
      name: "appliances_timeline",
      components: { default: appliancesTimeline }
    },
    {
      path: "appliances/run-profile",
      name: "appliances_run_profile",
      components: { default: appliancesRunProfile }
    },
    // {
    //   path: "imprints-map",
    //   name: "imprints_map",
    //   components: { default: imprintsMap }
    // },
    {
      path: "appliances/shapes/rising",
      name: "rising_shapes",
      components: { default: appliancesShapesRising }
    },
    {
      path: "appliances/shapes/falling",
      name: "falling_shapes",
      components: { default: appliancesShapesFalling }
    },
    {
      path: "settings",
      name: "settings",
      components: { default: NILMSettings },
      beforeEnter: (to, from, next) => {
        ownerAccess(to, from, next);
      },
    },
    {
      path: "anomaly",
      name: "anomaly_models",
      components: { default: AnomalyChart }
    },
  ]
};


const devicesVisualization = {
  path: "/visualization",
  component: DashboardLayout,
  redirect: "visualization/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    visualizationAccess(to, from, next);
  },
  children: [
    {
      path: "realtime",
      component: RealTimeDataManager,
      redirect: "realtime/voltage",
      children: [
        {
          path: "voltage",
          name: "realtime_voltage",
          components: { default: RealTimeVoltage }
        },
        {
          path: "current",
          name: "realtime_current",
          components: { default: RealTimeCurrent }
        },
        {
          path: "power/active",
          name: "realtime_active_power",
          components: { default: RealTimeActivePower }
        },
        {
          path: "power/reactive",
          name: "realtime_reactive_power",
          components: { default: RealTimeReactivePower }
        },
        {
          path: "power/apparent",
          name: "realtime_apparent_power",
          components: { default: RealTimeApparentPower }
        },
        {
          path: "energy/import",
          name: "realtime_energy_import_profile",
          components: { default: RealTimeEnergyImport }
        },
        {
          path: "energy/export",
          name: "realtime_energy_export_profile",
          components: { default: RealTimeEnergyExport }
        },
        {
          path: "frequency",
          name: "realtime_frequency",
          components: { default: RealTimeFrequency }
        },
        {
          path: "power-factor",
          name: "realtime_powerfactor",
          components: { default: RealTimePowerFactor }
        },
        {
          path: "distoration-factor/voltage",
          name: "realtime_distoration_factor_voltage",
          components: { default: RealTimeDistorationFactorVoltage }
        },
        {
          path: "distoration-factor/current",
          name: "realtime_distoration_factor_current",
          components: { default: RealTimeDistorationFactorCurrent }
        },
        {
          path: "energy/reactive",
          name: "realtime_reactive_energy",
          components: { default: RealTimeReactiveEnergy }
        },
        {
          path: "energy/apparent",
          name: "realtime_apparent_energy",
          components: { default: RealTimeApparentEnergy }
        }
      ]
    },
    {
      path: "profile/voltage",
      name: "voltage_profile",
      components: { default: VoltageProfile }
    },
    {
      path: "profile/current",
      name: "current_profile",
      components: { default: CurrentProfile }
    },
    {
      path: "profile/power/active",
      name: "active_power_profile",
      components: { default: ActivePower }
    },
    {
      path: "profile/power/reactive",
      name: "reactive_power_profile",
      components: { default: ReactivePower }
    },
    {
      path: "profile/power/apparent",
      name: "apparent_power_profile",
      components: { default: ApparentPower }
    },
    {
      path: "profile/energy/import",
      name: "energy_import_profile",
      components: { default: EnergyImport }
    },
    {
      path: "profile/energy/export",
      name: "energy_export_profile",
      components: { default: EnergyExport }
    },
    {
      path: "profile/energy/reactive",
      name: "energy_reactive_profile",
      components: { default: ReactiveEnergyProfile }
    },
    {
      path: "profile/energy/apparent",
      name: "energy_apparent_profile",
      components: { default: ApparentEnergyProfile }
    },
    {
      path: "profile/frequency",
      name: "frequency_profile",
      components: { default: FrequencyProfile }
    },
    {
      path: "profile/power-factor",
      name: "power_factor_profile",
      components: { default: PowerFactorProfile }
    },
    {
      path: "profile/distoration-factor/voltage",
      name: "profile_distoration_factor_voltage",
      components: { default: DistorationFactorVoltageProfile }
    },
    {
      path: "profile/distoration-factor/current",
      name: "profile_distoration_factor_current",
      components: { default: DistorationFactorCurrentProfile }
    },
    {
      path: "power/15min/maximum",
      name: "maximum_active_energy_15min",
      components: { default: Power15MinMaximum }
    },
    // {
    //   path: "energy/active/15min/maximum",
    //   name: "maximum_active_energy_15min",
    //   components: { default: Energy15MinMaximum }
    // },
    {
      path: "energy/active/15min",
      name: "active_energy_15min",
      components: { default: Energy15Min }
    },
    {
      path: "energy/active/hour",
      name: "hourly_active_energy",
      components: { default: EnergyHour }
    },
    {
      path: "energy/active/day",
      name: "daily_active_energy",
      components: { default: EnergyDay }
    },
    {
      path: "energy/active/month",
      name: "monthly_active_energy",
      components: { default: EnergyMonth }
    },
    {
      path: "energy/reactive/day",
      name: "daily_reactive_energy",
      components: { default: ReactiveDay }
    }
  ]
};

const deviceMerito = {
  path: "/merito",
  component: DashboardLayout,
  redirect: "merito/dashboard",
  name: "Merito",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.merito.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "merito/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          components: { default: Dashboard }
        },
        {
          path: "dashboard/recognition",
          name: "dashboard_merito_recognition",
          components: { default: Dashboard2 }
        },
        {
          path: "nilm/appliances/recording",
          name: "appliances_recording",
          beforeEnter: (to, from, next) => {
            NILMAccess(to, from, next);
          },
          components: { default: appliancesRecording }
        }
      ]
    },
    {
      path: "add-tarif",
      name: "addtarif",
      components: { default: AddTarif }
    }
  ]
}

const deviceDisconnector = {
  path: "/disconnector",
  component: DashboardLayout,
  redirect: "disconnector/dashboard",
  name: "Disconnector",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.disconnector.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "disconnector/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard_disconnector",
          components: { default: disconnectorDashboard }
        }
      ]
    },
    {
      path: "timeline",
      name: "disconnector_timeline",
      components: { default: disconnectorTimeline }
    },
    {
      path: "profile",
      name: "disconnector_energy_profile",
      components: { default: disconnectorProfile }
    },
    {
      path: "energy/hour",
      name: "hourly_active_energy",
      components: { default: disconnectorEnergyHour }
    },
    {
      path: "energy/day",
      name: "daily_active_energy",
      components: { default: disconnectorEnergyDay }
    },
    {
      path: "energy/month",
      name: "monthly_active_energy",
      components: { default: disconnectorEnergyMonth }
    }
  ]
}

const domainAppliedPrecision = {
  path: "/applied-precision",
  component: DashboardLayout,
  redirect: "applied-precision/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.precision.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "applied-precision/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard_precision",
          components: { default: precisionDashboard }
        },
        {
          path: "vector",
          name: "vector_chart",
          components: { default: ap_vectorDiagram }
        },
      ]
    },
    {
      path: "meters",
      name: "meters_list",
      components: { default: ap_meters }
    },
    {
      path: "meter/add",
      name: "meter_add",
      components: { default: ap_addMeter }
    },
    {
      path: "meter/tests",
      name: "meter_tests",
      components: { default: ap_meters_tests }
    },
    {
      path: "harmonics",
      name: "harmonics_chart",
      components: { default: ap_harmonicsChart }
    },
    {
      path: "waveform",
      name: "wavefrom_chart",
      components: { default: ap_waveformChart }
    }
  ]
}

const deviceOctopus = {
  path: "/octopus",
  component: DashboardLayout,
  redirect: "octopus/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.octopus.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "octopus/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          components: { default: OctopusDashboard }
        }
      ]
    }
  ]
};

const deviceOutageDetector = {
  path: "/outage-detector",
  component: DashboardLayout,
  redirect: "outage-detector/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.outage_detector.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "outage-detector/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          components: { default: OutageDetectorDashboard }
        },
        {
          path: "realtime/voltage",
          name: "realtime_voltage",
          components: { default: OutageDetectorVoltageRealtime }
        },
      ]
    },
    {
      path: "profile/voltage",
      name: "voltage_profile",
      components: { default: OutageDetectorVoltageProfile }
    }
  ]
};


const deviceMeriToNano = {
  path: "/meritonano",
  component: DashboardLayout,
  redirect: "meritonano/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.meritonano.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "meritonano/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          components: { default: MeriToNanoDashboard }
        }
      ]
    },
    {
      path: "profile/voltage",
      name: "voltage_profile",
      components: { default: OutageDetectorVoltageProfile }
    }
  ]
};


const toolsMenu = {
  path: "tools",
  component: DashboardLayout,
  redirect: "tools/monitoring",
  beforeEnter: requireAuth,
  children: [
    {
      path: "monitoring",
      name: "monitoring",
      components: { default: Monitoring }
    },
    {
      path: "device/settings",
      name: "device_settings",
      components: { default: DevicesSettings }
    },
    {
      path: "integration",
      name: "integration",
      components: { default: Integration },
      beforeEnter: (to, from, next) => {
        integrationAccess(to, from, next);
      },
    },
    {
      path: "upgrade",
      name: "firmware_upgrade",
      components: { default: Upgrade }
    },
    {
      path: "notifications",
      name: "notifications",
      components: { default: Notifications }
    }
  ]
};

const applications = {
  name: "applications_default",
  path: "applications",
  component: ApplicationsLayout,
  redirect: to => {
    if (getAuth().applications.length > 0) {
      switch(getAuth().applications[0]){
        case "ACCU_TEST":
        return { path: "/applications/accutest/profile"}
        case "REPORT":
        return { path: "/applications/report/energy/active/import"}
        case "CONTROLLER":
        return { path: "/applications/controller/state"}
        case "USER_MANAGER":
        return { path: "/applications/user-manager"}
      }
    } else {
      return { path: handleRedirect() };
    }
  } ,
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    applicationAccess(to, from, next);
  },
  children: [
    {
      path: "",
      component: accuTest_WS_Manager,
      redirect: "accutest/profile",
      children: [
        {
          path: "accutest/testing",
          name: "accutest_testing",
          components: { default: accuTest_testing },
          beforeEnter: (to, from, next) => {
            appAcces(to, from, next, "ACCU_TEST");
          }
        }
      ]
    },
    {
      path: "accutest",
      redirect: "accutest/profile",
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "ACCU_TEST");
      }
    },
    {
      path: "accutest/profile",
      name: "accutest_profile",
      components: { default: accuTest_createTestProfile },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "ACCU_TEST");
      }
    },
    {
      path: "accutest/results",
      name: "accutest_results",
      components: { default: accutest_results },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "ACCU_TEST");
      }
    },
    {
      path: "report/energy/active/import",
      name: "active_energy_report",
      components: { default: report_activeEnergyImport },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "REPORT");
      }
    },
    {
      path: "report/energy/active/export",
      name: "active_energy_report",
      components: { default: report_activeEnergyExport },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "REPORT");
      }
    },
    {
      path: "report/energy/reactive",
      name: "reactive_energy_report",
      components: { default: report_reactiveEnergy },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "REPORT");
      }
    },
    {
      path: "controller/state",
      name: "controller_state",
      components: { default: controller_state },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "CONTROLLER");
      }
    },
    {
      path: "controller/timeline",
      name: "controller_timeline",
      components: { default: controller_timeline },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "CONTROLLER");
      }
    },
    {
      path: "controller/map",
      name: "control_map",
      components: { default: controller_map },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "CONTROLLER");
      }
    },
    {
      path: "user-manager",
      name: "user_manager",
      components: { default: userManager },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "USER_MANAGER");
      }
    },
  ]
};

const publicPages = {
  path: "",
  component: PublicWebSocketManager,
  redirect: "/public/dashboard",
  children: [
    {
      path: "public",
      name: "public_default",
      component: PublicLayout,
      redirect: "public/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          meta: { hideFooter: true, hideTopNavBar: true},
          components: { default: PublicDashboard }
        }
      ]
    }
  ]

};

const singlePages = {
  path: "user",
  component: DashboardLayout,
  redirect: handleRedirect,
  children: [
    {
      path: "edit-profile",
      name: "edit_profile",
      components: { default: EditProfile },
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, next);
        userAccess(to, from, next);
      },
    }
  ]
};


const authPages = {
  path: "/login",
  component: AuthLayout,
  children: [
    {
      path: "",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "",
    component: WSConnectManager,
    name: "WSConnect",
    children: [
      {
        path: "",
        component: WSDevicesManager,
        redirect: "/login",
        name: "Devices",
        children: [
          devicesVisualization,
          deviceMerito,
          deviceMeritoNILM,
          deviceDisconnector,
          domainAppliedPrecision,
          deviceOctopus,
          deviceOutageDetector,
          deviceMeriToNano,
          toolsMenu,
          singlePages,
        ]
      },
      {
        path: "",
        component: WSApplicationsManager,
        name: "Applications",
        children: [
          applications
        ]
      }
    ]
  },
  authPages,
  publicPages,

  //DEFAULT ROUTE TODO: 404
  { path: "*", redirect: handleRedirect }
];

export default routes;
